module.exports = __webpack_public_path__ + "assets/GoldXi2x.405ce2baf0ca270f969f0bc712efbfe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldXi2x.png
// module id = 826
// module chunks = 0